import {useState} from "react";
import {useLocation, useOutletContext, useParams} from "react-router-dom";
import {PerdidasService} from "abastecemento/service";
import {perdidas_view_adapter} from "abastecemento/model";
import {useNavigateWithReload} from "base/hooks";
import {EntityUpdatePanel} from "base/entity";
import {PerdidasForm} from "../presentational/form";

const UpdatePerdidasPanel = () => {
    const {codigo, section} = useParams();
    const location = useLocation();
    const baseLocationPath = location.pathname.split(section)[0];

    const [error, setError] = useState("");
    const navigate = useNavigateWithReload();

    let perdidas;
    [perdidas] = useOutletContext();

    const handleSubmit = perdidas => {
        PerdidasService.update(perdidas_view_adapter({...perdidas}))
            .then(() => {
                navigate(baseLocationPath, true);
            })
            .catch(error => {
                setError(error);
            });
    };

    const handleFormCancel = () => {
        navigate(baseLocationPath);
    };

    return (
        <EntityUpdatePanel
            form={
                <PerdidasForm
                    perdidas={perdidas}
                    updatedSection={section}
                    onSubmit={handleSubmit}
                    onCancel={handleFormCancel}
                />
            }
            title="Modificar pérdidas"
            error={error}
            onCancel={handleFormCancel}
        />
    );
};

export default UpdatePerdidasPanel;
